import React from "react"
import ProductModelBase from "theme/base/shop/ProductModel"
import {Icon} from "semantic-ui-react"
import shop from "shop/shop"

export default class ProductModel extends ProductModelBase {
  
  constructor( data ) {
    super( data );
  }
  
  getNotice = ( size ) => {
    const notice = <AvailabilityNotice size={size} product={this}/>
    return notice
  }
}

function AvailabilityNotice({product, size}) {
  const stock = Number(product.extraValue.stockFlag) || 0
  let text = translate("Artikel verfügbar und sofort lieferbar")
  let color = "green"
  
  if( stock === 0){
    text = translate("Auf Bestellung, schnell verfügbar")
    color= "yellow"
  }
  
  if( stock === 1){
    text = translate("Artikel verfügbar und sofort lieferbar")
  
    color= "green"
  }
  
  
  if(size === "tiny"){
    return <div className={"Availability"}>
      <span className={""}><Icon title={text} name="truck" color={color} /></span>
    </div>
  }
  
  return <div className={"Availability"}>
    <span className={""}><Icon title={text} name="truck" color={color} /> {text}</span>
  </div>
}


// WEBPACK FOOTER //
// ./src/theme/orfix-test/shop/ProductModel.js